<template>
  <div class="submit-result-wrap">
    <i :class="isSuccess?'icon-ok':'icon-error'" class="icon-result"></i>
    <div class="submit-success">提交成功</div>
    <div class="thanks">感谢您的参与！<a @click="$router.push('/home/mySpeakingTasksList')">点击此处返回我的实操任务</a></div>
  </div>
</template>
<script>

  export default {
    name: 'ResultView',
    components: {},
    data() {
      return {
        isSuccess: true,
        loading: true
      }
    },
    filters: {},
    methods: {
    },
    //获取数据
    created() {
    }
  }
</script>
<style lang="less">
  .submit-result-wrap {
    height: 100%;
    margin-bottom: 0.3rem;
    padding-bottom: 0.32rem;
    background: #fff;
    border: 1px solid #E8ECEF;
    border-radius: 0.1rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    text-align: center;

    .icon-result {
      display: block;
      width: 93px;
      height: 93px;
      margin: 100px auto 0.3rem;

      &.icon-ok {
        background: url('../../assets/icons/ic_chenggong@2x.png') center/100% 100% no-repeat;
      }

      &.icon-error {
        background: url('../../assets/icons/ic_shibai@2x.png') center/100% 100% no-repeat;
      }
    }

    .submit-success {
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      font-size: 32px;
      line-height: 42.67px;
      text-align: center;
    }

    .thanks {
      margin-top: 10px;
      margin-bottom: 106px;
      color: rgba(0, 0, 0, 0.45);
      font-size: 16px;
      line-height: 29.33px;
      text-align: center;
    }

  }
</style>
